import { useContext } from "react";

import { NavigateFunction } from "./NavigateFunction";
import { RouteGenerators } from "./RouteGenerators";
import { RouterContext } from "./RouterContext";

export function useRouter(): {
    navigate: NavigateFunction;
    routeTo: RouteGenerators;
} {
    const { navigate, routeTo } = useContext(RouterContext);
    return { navigate, routeTo };
}
